import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {FirebaseApp} from 'angularfire2';

@Injectable()
export class ContactosService {
    firebaseStorage: any;

  constructor(private afDB:AngularFireDatabase, private http:HttpClient,private firebaseApp: FirebaseApp,) {
      this.firebaseStorage = firebaseApp.storage().ref()
  }

  // Obtener todos los contactos
  public obtenerTodosLosContactos(){
    return this.afDB.list('/contactos/');
  }

  // Crea un contacto para un cliente en específico cliente
  public crearContactoCliente(idCliente,contacto){
    contacto.cliente = idCliente;

    // Crea un key de firebase
    let firebaseKey = this.afDB.list('/').push(undefined).key;

    // Crea un nuevo contacto en multiples nodos de la base de datos
    let multipathUpdate = {};
    multipathUpdate['/contactos/' + firebaseKey] = contacto;
    multipathUpdate['/contactosPorCliente/' + idCliente + '/' + firebaseKey] = contacto;
    multipathUpdate['/clientes/' + idCliente + '/contactos/' + firebaseKey] = true;

    return this.afDB.object('/').update(multipathUpdate);
  }
  public crearContactoClienteAcceso(idCliente,contacto, idContacto){
    contacto.cliente = idCliente;

    // Crea un nuevo contacto en multiples nodos de la base de datos
    let multipathUpdate = {};
    multipathUpdate['/contactosConAcceso/' + idContacto] = contacto;
    multipathUpdate['/contactosPorClienteConAcceso/' + idCliente + '/' + idContacto] = contacto;
    multipathUpdate['/clientes/' + idCliente + '/contactosConAcceso/' + idContacto] = true;

    return this.afDB.object('/').update(multipathUpdate);
  }

  // Elimina un contacto del cliente
  public eliminarContacto(contacto){

    let idCliente = contacto.cliente;
    let idContacto = contacto.$key;

    let multipathUpdate = {};
    multipathUpdate['/contactos/' + idContacto] = null;
    multipathUpdate['/contactosPorCliente/' + idCliente + '/' + idContacto] = null;
    multipathUpdate['/clientes/' + idCliente + '/contactos/' + idContacto] = null;

    return this.afDB.object('/').update(multipathUpdate);
  }

  // Actualiza la información del contacto seleccionado
  public actualizarContacto(contacto){

    let idCliente = contacto.cliente;
    let idContacto = contacto.$key;

    delete contacto.$key;

    let multipathUpdate = {};
    multipathUpdate['/contactos/' + idContacto] = contacto;
    multipathUpdate['/contactosPorCliente/' + idCliente + '/' + idContacto] = contacto;

    return this.afDB.object('/').update(multipathUpdate);
  }

  // Obtiene los contactos de un cliente en específico
  public obtenerContactosDeCliente(idCliente){
    return this.afDB.list('/contactosPorCliente/' + idCliente);
  }

  // Obtiene los contactos con acceso de un cliente en específico
  public obtenerContactosDeClienteConAcceso(idCliente){
    return this.afDB.list('/contactosPorClienteConAcceso/' + idCliente);
  }

  // Obtiene la información de un contacto en específico
  public obtenerContacto(idContacto){
    return this.afDB.object('/contactos/' + idContacto);
  }
  public obtenerPropiedadContacto(idContacto, propiedad){
    return this.afDB.object('/contactos/' + idContacto+ '/'+ propiedad);
  }

   /**
   * Cambia el estatus del cliente CON ACCESO
   */

  public desHabilitarCliente(idClienteAcceso:string, idCliente: string, deshabilitado: boolean) {
    this.afDB.object('/contactosPorClienteConAcceso/' + idCliente + '/' + idClienteAcceso + '/deshabilitado').set(deshabilitado)
    let body = {
        uid: idClienteAcceso,
        dehabilitado: deshabilitado
    };
    return this.http.post('https://us-central1-trosten-efcb3.cloudfunctions.net/app/desHabilitarUsuario', body);
}

    public crearContactoHubSpot(contacto,nombreCliente,de_donde_llego,tipo_de_venta){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'nombre=' + contacto.nombre +
            '&telefono='+contacto.telefono+
            '&email='+contacto.email+
            '&nombreCliente='+nombreCliente+
            '&de_donde_llego='+de_donde_llego+
            '&hs_analytics_source='+'OTHER_CAMPAIGNS'+
            '&tipo_de_venta='+tipo_de_venta;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Contacto/crearContacto.php', body,{headers});
    }

    public actualizarContactoHubSpot(contacto){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'idHubspot=' + contacto.idHubspot +
            '&nombre=' + contacto.nombre +
            '&telefono=' + contacto.telefono +
            '&email=' + contacto.email;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Contacto/actualizarContacto.php', body, {headers});
    }

    public subirIdOficial(idContacto, file){
        return this.firebaseStorage.child('ids/' +idContacto+'/'+ file.name).put(file)
    }

    public actualizarIdContacto(idContacto, idCliente, link)
    {
        let multipathUpdate = {};
        multipathUpdate['/contactos/' + idContacto+ '/id_link'] = link
        multipathUpdate['/contactosPorCliente/' + idCliente + '/' + idContacto+ '/id_link'] = link;
        return this.afDB.object('/').update(multipathUpdate);
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/contactos.service.ts